"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.naturalCompare = naturalCompare;
/**
 * Compares two strings naturally. Substrings of digits are compared as numbers, and other substrings are compared as strings.
 * @param a The first string to compare.
 * @param b The second string to compare.
 * @returns A negative number if a < b, a positive number if a > b, and 0 if a === b.
 */
function naturalCompare(a, b) {
  a = a.toString().toLowerCase();
  b = b.toString().toLowerCase();
  let aCur = 0;
  let bCur = 0;
  while (true) {
    let aToken = getNextToken(a, aCur);
    let bToken = getNextToken(b, bCur);
    aCur += aToken.length;
    bCur += bToken.length;

    // If one or both tokens are empty, return
    if (aToken === '' && bToken === '') return 0;
    if (aToken === '') return -1;
    if (bToken === '') return 1;

    // If both tokens are digits, compare them as numbers
    if (isDigit(aToken, 0) && isDigit(bToken, 0)) {
      let aNum = parseInt(aToken);
      let bNum = parseInt(bToken);
      if (aNum !== bNum) {
        return aNum - bNum;
      }
    }

    // Compare as strings
    let n = aToken.toString().localeCompare(bToken.toString());
    if (n) return n;
  }
}

/**
 * Returns true if the character at index i in string s is a digit
 * @param s The string to check
 * @param i The index to check
 * @returns True if the character at index i in string s is a digit
 */
function isDigit(s, i) {
  return s.charCodeAt(i) >= 48 && s.charCodeAt(i) <= 57;
}

/**
 * Gets the next token from a string s, starting from startIndex, where a token is a substring of all digits or all non-digits
 * @param s The string to get the token from
 * @param startIndex The index to start searching for the token
 * @returns A string containing all digits or all non-digits, extracted from string s starting at startIndex
 */
function getNextToken(s, startIndex) {
  if (startIndex >= s.length) return '';
  // Indicies of characters that change from digit to non-digit or vice versa
  let lastIsDigit = isDigit(s, startIndex);
  let endIndex;
  for (endIndex = startIndex; endIndex < s.length; endIndex++) {
    if (lastIsDigit !== isDigit(s, endIndex)) {
      break;
    }
  }
  return s.substring(startIndex, endIndex);
}